import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const DotacionFuncionarios = () => {
  return (
    <div>
        <h2 className='tituloAccion'>Dotación de Funcionarios T.B.C. (Periféricos)</h2>
        Por ahora nada
    </div>
  )
}

export default DotacionFuncionarios